import HuitabHeader from '../../shared/components/common/huitab-header';
import { HuitabPageManager, PageManager } from '../../shared/services/page-manager';
import { PageTypes } from '../../shared/services/settings-loader';
import { TagCommanderManager } from '../../shared/services/tag-commander-manager';

require('../../core/require');
require('./page.scss');

export const AIDE_ET_CONTACT_TABS = {
  numerosLiensUtiles: {
    idTab: 'Numeros-liens',
    libelle: 'Numéros et liens utiles',
    tag: {
      chapitre_1: 'aide_et_contacts',
      chapitre_2: 'numeros_et_liens_utiles',
      page: 'numeros_et_liens_utiles',
    },
  },
  demandesEnLigne: {
    idTab: 'Demandes',
    libelle: 'Demandes en ligne',
    tag: {
      chapitre_1: 'aide_et_contacts',
      chapitre_2: 'demandes_en_ligne',
      page: 'demandes_en_ligne',
    },
  },
};

// Lorsqu'on navigue directement vers un onglet spécifique via
// l'url, on déclenche un appel manuel
window.addEventListener('load', function () {
  if (PageManager.current === PageTypes.NUMEROS_LIENS) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const currentTab = urlSearchParams.get('idTab');

    if (currentTab === AIDE_ET_CONTACT_TABS.demandesEnLigne.idTab) {
      changerTab(AIDE_ET_CONTACT_TABS.demandesEnLigne);
    } else {
      changerTab(AIDE_ET_CONTACT_TABS.numerosLiensUtiles);
    }
  }
});

// Mise à jour du contenu du fil d'ariane et du paramètre
// idTab dans l'url lorsqu'on change d'onglet
Object.values(AIDE_ET_CONTACT_TABS).forEach((tab) => {
  const navTabElement = getNavTabElement(tab.idTab);

  if (navTabElement) {
    navTabElement.addEventListener('click', () => {
      changerTab(tab);
    });
  }
});

/* *************************************************************************************************** */
/* *********************************** Affichage des onglets ***************************************** */
/* *************************************************************************************************** */

/**
 * Activation de l'ensemble des actions à mettre à jour suite au changement d'onglet
 * @param tab onglet à activer (cf. constante AIDE_ET_CONTACT_TABS)
 */
export function changerTab(tab) {
  activerNavTab(tab.idTab);
  HuitabPageManager.updateUrlFromIdTab(tab.idTab);
  updateFilAriane(tab.libelle);
  updateScrollBar(tab.idTab);
  TagCommanderManager.tagPage(tab.tag);
}

/**
 * Activation manuelle de l'onglet Bootstrap
 * @param idTab ID de l'onglet à activer
 */
function activerNavTab(idTab) {
  Object.values(AIDE_ET_CONTACT_TABS).forEach((tab) => {
    const navTabElement = getNavTabElement(tab.idTab);
    const navTabPaneElement = getNavTabPaneElement(tab.idTab);

    if (navTabElement) {
      if (idTab === tab.idTab) {
        navTabElement.classList.add('active');
        navTabElement.setAttribute('aria-selected', true);
      } else {
        navTabElement.classList.remove('active');
        navTabElement.setAttribute('aria-selected', false);
      }
    }

    if (navTabPaneElement) {
      if (idTab === tab.idTab) {
        navTabPaneElement.classList.add('show', 'active');
      } else {
        navTabPaneElement.classList.remove('show', 'active');
      }
    }
  });
}

/**
 * Mise à jour du fil d'ariane pour afficher l'onglet sélectionné
 * @param texte Texte à afficher
 */
function updateFilAriane(texte) {
  HuitabHeader.setFilArianeDesktop([
    { label: 'Aide et contact' },
    { label: 'Tableau de bord', href: '/' },
    { label: texte },
  ]);
}

/**
 * Mise à jour de la scroll bar pour défiler vers l'élément sélectionné
 * @param idTab ID de l'onglet vers lequel il faut défiler
 */
function updateScrollBar(idTab) {
  const navTabElement = getNavTabElement(idTab);

  if (navTabElement) {
    document.querySelector('.main-tab-navigation').scrollLeft = navTabElement.scrollWidth;
  }
}

function getNavTabElement(idTab) {
  return document.getElementById('nav-' + idTab.toLowerCase() + '-tab');
}

function getNavTabPaneElement(idTab) {
  return document.getElementById('nav-' + idTab.toLowerCase());
}
